import React, { useEffect, useState } from "react";
import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import BlogSidebar from "../components/BlogSidebar.jsx";
import MyPhilosophy from "../components/MyPhilosophy.jsx";
import BlogComponent from "../components/BlogComponent.jsx";
import { CategoryProvider } from "../contexts/CategoryContext"; // Import the provider
import AOS from 'aos';
import { Helmet } from "react-helmet";
import SEO from "../components/SEO.jsx";
const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const handleCategorySelect = (categorySlug) => {
    setSelectedCategory(categorySlug);
  };
  const handleSearch = (query) => {
    setSearchQuery(query);
  };


  useEffect(() => {
          
              // Initialize AOS animations only on the client-side
              AOS.init({
                  duration: 1200
              });
          })
  return (
    <CategoryProvider> {/* Wrap the page with the CategoryProvider */}
    
      <SEO
      page="blogs"
      customMeta={{
        title: "Blogs - Shape Shifting Mastery",
        description: "Expert articles on fitness, nutrition, mindset, and transformation. Stay updated with the latest insights and tips for your journey.",
      }}
    />
      {/* <Helmet>
  <title>Blogs - Shape Shifting Mastery</title> 
  <meta name="description" content='Read more about our Blogs.' />
  <meta name="keywords" content='blogData.seo_keywords' />
</Helmet> */}
      {/* MyPhilosophy Section */}
      <MyPhilosophy />

      {/* Blog List Section */}
      <section className="blog-list sec_padding">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-md-4" data-aos="fade-right">
              <h6 className="sub_heading">Blogs</h6>
              <h2 className="sec_heading-stylish">Together We Will</h2>
            </div>
            <div className="col-md-9">
              <div className="row">
                <BlogComponent selectedCategory={selectedCategory} searchQuery={searchQuery} />
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <BlogSidebar onCategorySelect={handleCategorySelect} onSearch={handleSearch}/>
            </div>
          </div>
        </div>
      </section>

     
    </CategoryProvider>
  );
};

export default BlogPage;
